<template>
  <v-container style="height: 100%">
    <v-row style="height: 100%">
      <v-col class="d-flex justify-center align-center">
        <v-sheet elevation="8" class="pa-8" rounded width="400">
          <h2 class="text-center mb-5">パスワード変更</h2>
          <v-form
              ref="editPassForm"
              v-model="editPassFormValid"
              lazy-validation
          >

            <v-text-field
                v-model="inputChangePass.old_password"
                label="古いパスワード*"
                outlined
                dense
                hide-details="auto"
                :type="showOldPassword ? 'text' : 'password'"
                :rules="[(v) => (!!v && !!v.trim()) || '古いパスワードを入力してください。',
                 v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || '大文字1つ、小文字1つ、数字1つを最低限含む8文字以上のパスワードを入力してください。',
                 inputErrorCheck.old_password]"
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showOldPassword = !showOldPassword"
                counter
                clearable
                @focusin="resetValidate('old_password')"
            ></v-text-field>
            <v-text-field
                v-model="inputChangePass.new_password1"
                label="新規パスワード*"
                outlined
                dense
                hide-details="auto"
                :type="showNewPassword ? 'text' : 'password'"
                :rules="[
                    (v) => (!!v && !!v.trim()) || '新規パスワードを入力してください。',
                    v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || '大文字1つ、小文字1つ、数字1つを最低限含む8文字以上のパスワードを入力してください。',
                    inputErrorCheck.new_password2
                    ]"
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showNewPassword = !showNewPassword"
                counter
                clearable
                @focusin="resetValidate('new_password2')"
            ></v-text-field>
            <v-text-field
                v-model="inputChangePass.new_password2"
                label="新規パスワード確認*"
                outlined
                dense
                hide-details="auto"
                :type="showConfirmPassword ? 'text' : 'password'"
                :rules="[
                    (v) => (!!v && !!v.trim()) || '新規パスワード確認を入力してください。',
                    v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || '大文字1つ、小文字1つ、数字1つを最低限含む8文字以上のパスワードを入力してください。',
                    inputErrorCheck.new_password2
                    ]"
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showConfirmPassword = !showConfirmPassword"
                counter
                clearable
                @focusin="resetValidate('new_password2')"
            ></v-text-field>
          </v-form>
          <div v-for="(error, idx) in inputError" :key="idx">
            <span class="text-caption red--text">{{error}}</span>
          </div>
          <v-btn
              class="mt-4"
              style="width:100%;"
              depressed color="primary"
              @click="changePassword()"
          >
            変更
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {store} from "@/store";

export default {
  name: "ChangePassword",

  data() {
    return {
      inputChangePass: {
        new_password1: null,
        new_password2: null,
        old_password: null,
      },
      inputErrorCheck: {
        old_password: true,
        new_password2: true
      },
      inputError: [],
      editPassFormValid: true,
      sharedState: store.state,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false
    }
  },

  methods: {
    changePassword() {
      if (this.$refs.editPassForm.validate()) {
        this.axios
            .post("/api/dj-rest-auth/password/change/", this.inputChangePass)
            .then(() => {
              // this.logout();
              this.$router.back();
              store.showSuccessDialog("パスワードが変更されました。");

            })
            .catch((error) => {
              if (error.response.status == 400) {
                if ('old_password' in error.response.data) {
                  // store.showErrorDialog(error.response.data.old_password[0]);
                  this.inputError = error.response.data.old_password;
                  this.inputErrorCheck.old_password = false
                }
                if ('new_password2' in error.response.data) {
                  // store.showErrorDialog(error.response.data.new_password2[0]);
                  this.inputError = error.response.data.new_password2;
                  this.inputErrorCheck.new_password2 = false
                }
              } else {
                store.showErrorDialog("エラーが発生しました。再度試してください。");
              }
            });
      }
    },

    logout() {
      const token = this.sharedState.token;
      this.axios
          .post("/api/dj-rest-auth/logout/", {access_token: token})
          .then(() => {
            this.setLogoutStatus();
            this.$router.push("/login");
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          });
    },
    setLogoutStatus() {
      store.updateLogoutStatus();
      this.axios.defaults.headers.common["Authorization"] = "";
    },
    resetValidate(input){
      this.inputErrorCheck[input] = true;
      this.inputError = [];
    }
  },

}
</script>

